<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        Scan Stock
      </h1>
      <div class="container">
        <ag-grid-vue
          style="width: 100%; height: 1000px;"
          class="ag-theme-alpine"
          :modules="modules"
          :pagination="true"
          :pagination-auto-page-size="true"
          :group-display-type="groupDisplayType"
          :grid-options="gridOptions"
          :row-data="stock"
          :column-defs="columnDefs"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { AllModules } from '@ag-grid-enterprise/all-modules'
import Enduser from '@/services/v2/enduser'

export default {
  data () {
    return {
      modules: AllModules,
      groupDisplayType: 'custom',
      isLoading: false,
      formattedStock: {},
      stock: [],
      gridOptions: {
        autoGroupColumnDef: {
          headerName: 'Date'
        } },
      columnDefs: [
        { headerName: 'Date',
          field: 'date',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return params.value.split('T')[0]
          },
          rowGroup: true,
          hide: true
        },
        { headerName: 'Barcode',
          field: 'barcode'
        }
      ]

    }
  },
  computed: {
    ...mapState({
      selectedCustomer: state => state.selectedCustomer
    })
  },
  watch: {
    selectedCustomer: {
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue) {
          this.getStock()
        }
      }
    }
  },
  async mounted () {
  },
  methods: {
    async getStock () {
      if (!this.selectedCustomer) return
      this.isLoading = true
      try {
        const response = await Enduser.getScanStock(this.selectedCustomer)
        this.stock = response
      } catch (error) {
        this.$buefy.toast.open({
          message: error.message || error,
          type: 'is-danger'
        })
      }

      this.isLoading = false
    }
  }
}
</script>
